import { render, staticRenderFns } from "./ExtraFeatures.vue?vue&type=template&id=382cdb78&scoped=true"
import script from "./ExtraFeatures.vue?vue&type=script&lang=js"
export * from "./ExtraFeatures.vue?vue&type=script&lang=js"
import style0 from "./ExtraFeatures.vue?vue&type=style&index=0&id=382cdb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382cdb78",
  null
  
)

export default component.exports